"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Awning = void 0;
const Component_1 = require("./Component");
class Awning extends Component_1.Component {
    static open() {
        return {
            intended: {
                s: { state: 'open' },
            },
            futureReported: {
                s: { state: 'moving' },
            },
        };
    }
    static close() {
        return {
            intended: {
                s: { state: 'close' },
            },
            futureReported: {
                s: { state: 'moving' },
            },
        };
    }
    static stop() {
        return {
            intended: {
                s: { state: 'stop' },
            },
            futureReported: {
                s: { state: 'partially_open' },
            },
        };
    }
    static turnLightOn() {
        return {
            intended: {
                s: { lightOn: true },
            },
            futureReported: {
                s: { lightOn: true },
            },
        };
    }
    static turnLightOff() {
        return {
            intended: {
                s: { lightOn: false },
            },
            futureReported: {
                s: { lightOn: false },
            },
        };
    }
    static toggleLight({ currentState }) {
        if (!currentState) {
            throw new Error('currentState was not provided.');
        }
        if (currentState.lightOn) {
            return Awning.turnLightOff();
        }
        return Awning.turnLightOn();
    }
}
exports.Awning = Awning;
//# sourceMappingURL=Awning.js.map